var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.allNotifications),function(popup){return _c('v-snackbar',{key:popup.created_at,attrs:{"timeout":2000,"rounded":"pill","color":"blue-gray","value":true}},[_vm._v(" "+_vm._s(popup.text)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }